@if (isLoading) {
  <app-loader></app-loader>
}

<main class="content-wrapper">
  <div class="container-fluid mb-4">
    <section class="reports-card">
      <div class="reports-header">
        <div>
          <h1>Attendance Reports</h1>
          <p>Monthly request breakdown by employee.</p>
        </div>

        <mat-form-field appearance="outline" class="month-picker-field">
          <mat-label>Select Month</mat-label>
          <mat-select [value]="selectedMonth" (selectionChange)="onMonthChange($event.value)">
            <mat-option *ngFor="let month of monthOptions" [value]="month.value">
              {{ month.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      @if (errorMessage) {
        <div class="state state-error">{{ errorMessage }}</div>
      }

      @if (!isLoading && !errorMessage && reports.length === 0) {
        <div class="state state-empty">No data found for {{ selectedMonth }}.</div>
      }

      @if (!isLoading && reports.length > 0) {
        <div class="table-wrap">
          <table class="reports-table">
            <thead>
              <tr>
                <th>Full Name</th>
                <th>Total Requests</th>
                <th>Overtime Requests</th>
                <th>Check-in Requests</th>
                <th>Check-out Requests</th>
                <th>Approved</th>
                <th>Rejected</th>
                <th>Pending</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of reports; trackBy: trackByUserId">
                <td>{{ row.full_name }}</td>
                <td>{{ row.total_requests }}</td>
                <td>{{ row.overtime_requests }}</td>
                <td>{{ row.checkin_requests }}</td>
                <td>{{ row.checkout_requests }}</td>
                <td>{{ row.approved }}</td>
                <td>{{ row.rejected }}</td>
                <td>{{ row.pending }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      }
    </section>
  </div>
</main>
